import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Printer, PrintService } from 'src/app/services/print.service';

@Component({
  selector: 'app-printers',
  templateUrl: './printers.component.html',
  styleUrls: ['./printers.component.scss']
})
export class PrintersComponent implements OnInit {

  @Output() selected = new EventEmitter<Printer>();

  public printer: Printer;

  constructor(public print: PrintService) { }

  ngOnInit(): void {
  }

  select(printer: Printer) {
    this.printer = printer;
    this.selected.emit(printer);
  }
}
